import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "dff-simpel-dialog",
    styleUrls: ["./dff-simpel-dialog.component.scss"],
    templateUrl: "./dff-simpel-dialog.component.html",
    host: {
        role: "dialog",
        "[attr.aria-labelledby]": "dialogTitle",
        "[attr.aria-describedby]": "dialogDesc"
    },
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class DffSimpelDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DffSimpelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    public dialogTitle = "dialogTitle";
    public dialogDesc = "dialogDesc";
}
